import useGlobalToast from '@centric-os/components/src/core/messages/toast/composables/use-global-toast';
import { useTranslation } from '@centric-os/helpers';
import { SitesLocalePrefix } from '../../../enums/locale-prefixs';

const LOCALE_PREFIX = SitesLocalePrefix.SITE_SCHEDULE_SIDE_PANEL;

/**
 * EN/FR copy for calendar PUT 409 (optimistic locking). Use in setup/composables or Vue SFCs when catching {@link CalendarRevisionConflictError}.
 */
export default function useCalendarRevisionConflictFeedback() {
  const { translate } = useTranslation();
  const { showErrorToast } = useGlobalToast();

  const showCalendarRevisionConflictToast = (): void => {
    showErrorToast(
      translate(`${LOCALE_PREFIX}.menuSchedulePanel.calendarRevisionConflictTitle`),
      translate(`${LOCALE_PREFIX}.menuSchedulePanel.calendarRevisionConflictDetail`),
    );
  };

  return { showCalendarRevisionConflictToast };
}
